/* card/reducer */
import { createReducer } from "typesafe-actions";
import { TerminalBackgroundTypes, TerminalBackgroundState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
} from "./actions";

export const initialState: TerminalBackgroundState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>;

export default createReducer<TerminalBackgroundState, ActionType>(initialState)
  .handleType(TerminalBackgroundTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(TerminalBackgroundTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(TerminalBackgroundTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
    };
  })
  .handleType(TerminalBackgroundTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(TerminalBackgroundTypes.SAVE_SUCCESS, (state, action) => {
    // let newState:any = state.data?.data;
    // let tempCompanies = newState[0]?.Companies
    // let tempPayload:any = action.payload.data
    // tempCompanies.push(tempPayload[0])
    // let temp:any = {data:[{Companies: tempCompanies}]}
    return {
      ...state,
      loading: false,
      // data: temp,
      errors: undefined,
    };
  })
  .handleType(TerminalBackgroundTypes.SAVE_ERROR, (state, action) => {
    let oldState: any = {...state};
    return {
      ...state,
      loading: false,
      // errors: action.payload,
      data: oldState.data
    };
  });
